import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const TrendingItemsChart = ({ data }) => {
  // Custom formatter to truncate names longer than 10 characters
  const truncateName = (name) =>
    name.length > 13 ? `${name.substring(0, 13)}...` : name;

  // Custom tick component for XAxis to wrap text
  const renderCustomTick = ({ x, y, payload }) => {
    const text = truncateName(payload.value);
    const words = text.split(" "); // Split by spaces
    const firstWord = words[0]; // Take the first word
    const restWords = words.slice(1).join(" "); // Combine the rest into a single string
    const lineSpacing = 14; // Vertical spacing between lines
    const marginTop = 7; // Add a top margin for spacing

    return (
      <g transform={`translate(${x},${y + marginTop})`}>
        {/* Render the first word */}
        <text
          x={0}
          y={0} // Start at the top
          textAnchor="middle"
          fontSize={11}
          fontWeight="bold" // Apply bold font weight
          fontFamily="Ubold" // Set font family to Ubold
          fill="#666"
        >
          {firstWord}
        </text>
        {/* Render the rest of the words below */}
        {restWords && (
          <text
            x={0}
            y={lineSpacing} // Position below the first word
            textAnchor="middle"
            fontSize={11}
            fontWeight="bold" // Apply bold font weight
            fontFamily="Ubold" // Set font family to Ubold
            fill="#666"
          >
            {restWords}
          </text>
        )}
      </g>
    );
  };


  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="name"
          tick={renderCustomTick} // Use custom tick for multi-line labels
          interval={0} // Ensure all names are shown
        />
        <YAxis
          tick={{
            fontSize: 18, // Adjust font size
          }}
        />
        <Tooltip
          formatter={(value, name, props) =>
            name === "name" ? props.payload.name : value
          }
        />
        <Legend />
        <Bar dataKey="sales" fill="#8884d8" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default TrendingItemsChart;
